export enum UserRole{
  Student="Student",
  Mentor="Mentor",
  Admin="Admin",
  SuperAdmin="SuperAdmin",
  PeerReviewer="PeerReviewer",
  SchoolAdmin="SchoolAdmin",
  Operations="Operations",
  Marketing="Marketing",
}

export enum Currency {
  Dollar=0,
  Rupee=1,
  Euro=2,
  Pound=3
}

// Function to get description by currency value
export function getCurrencyDescription(currency: Currency): string {
  switch (currency) {
    case Currency.Dollar:
      return "USD ($)";
    case Currency.Rupee:
      return "Rupee (₹)";
    case Currency.Euro:
      return "Euro (€)";
    case Currency.Pound:
      return "Pound (£)";
    default:
      return "USD ($)";
  }
}


